/* aculeve.js 07-12 
Some global functions
*/
// The breadcrumbs fit nicely in the blank space below the header, but we need
// them under the health dropdown. Z index does this, but makes them inaccessible
// when we mouse over the contact link. Following is a crappy (but working) Javascript workaround
// for something inherent in the design.
var timeout;
$(document).ready(function(){
    
    $("a[rel^='prettyPhoto']").prettyPhoto({
		show_title: false,
		theme: 'dark_rounded',
		opacity: 0.5
	});
	
  /*  if ($('#topnav li a').length) {
		$('#topnav li a').hover(function() { handleSubnav($(this).attr('id'),1); });
		$('#topnav li a').mouseleave(function() { handleSubnav($(this).attr('id'),0); });
		$('#topnav li ul li a').hover(function() { handleSubnav($(this).parents('li').closest('li').children('a').attr('id'),1); });
		$('#topnav li ul li a').mouseleave(function() { handleSubnav($(this).parents('li').closest('li').children('a').attr('id'),0); });
	}*/
	if ($('#img-container a').length) {
		var slideTimeout = null;
		var duration = 7000;
		var curr_ind=1;
		var len = $('#img-container a img').length;
		slideTimeout = setInterval( function() { curr_ind = slideSwitch(curr_ind,len) }, duration);
	}
	// Product page thumbs
	if ($('#thumbs li a').length) {
		$('#thumbs li a').click(function() {
            window.optimizely = window.optimizely || [];
     		window.optimizely.push(['trackEvent', 'thumbnail_img_clicked']);
			$('#large-thumb').attr('src',this.href);
			return false;
		});
	}
	// Checkout buttons
	if ($('#add-to-cart').length) {
		$('#add-to-cart').live("mousedown", function() {
            window.optimizely = window.optimizely || [];
     		window.optimizely.push(['trackEvent', 'add_cart_button_clicked']);
			return false;
		});
	}
});

// Main page animation
function slideSwitch(index,num_divs) {
	index=((index+1)>num_divs)?1:index+1;
    var $active = $('#img-container a img.active');
    if ( $active.length == 0 ) { $active = $('#img-container a img:last'); }
    // use this to pull the images in the order they appear in the markup
    var $next =  $active.next().length ? $active.next() : $('#img-container a img:first');
    $next.css({opacity: 0.0})
        .addClass('active')
        .animate({opacity: 1.0}, 2000, function() {
            $active.removeClass('active last-active');
	});
    $active.addClass('last-active');
	return index;
}

// accepts the id of the main nav anchor and state, 1 = show, 0 = hide.
/*function handleSubnav(objid,state) {
if (! objid) { return; }
//alert (' ob ' + objid + ' ' + state);
//return;

	var parent = $('#'+objid).parent('li');
	if (state==1) {
		if (timeout) { clearTimeout(timeout); }
		$(parent).css('height',26+'px');
		$('#'+objid).css('height',26+'px');
		if ($(parent).find('ul').length) { 
			$('#'+objid).css('backgroundPosition','100% 100%');
			$(parent).find('ul').css('display','block'); 
		}
		else { closeOpenMenus(); }
		
	}
	else {
		if ($(parent).find('ul').length) { 
			// Override hover from css to hold it open for our delay.
			$('#'+objid).css('backgroundPosition','100% 100%');
			timeout=setTimeout(function() { 
				$('#'+objid).css('backgroundPosition','top right');
				$(parent).css('height',26+'px');
				$('#'+objid).css('height',26+'px');
				$(parent).find('ul').css('display','none');
				}, 
			250);
		}
		else {
			$(parent).css('height',26+'px');
			$('#'+objid).css('height',26+'px');
		}
	}
}*/

// If you nav sideways, state is still 1. If there's no ul's, the call in the above function asks this to close all menus.

/*function closeOpenMenus() { 
	$('#topnav li').each(function (i) {
		if ($(this).children('ul').length) {
			$(this).children('a').css('backgroundPosition','top right');
			$(this).children('a').css('height',26+'px');
			$(this).css('height',26+'px');
			$(this).children('ul').css('display','none'); 
		}
	});
}*/

